<template>
  <div>
    <div style="text-align: center; padding-top: 5px;">
      <p>Would you like to modify task due dates to match the job?<br>
        Tasks will not be updated until job is saved.</p>
      <button type="button" @click="updateTasks" class="btn btn-fill btn-info">
        Yes
      </button>
      <button type="button" @click="doNotUpdateTasks" class="btn btn-fill btn-info">
        No
      </button>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
      updateTasks() {
        this.$store.set('jobs/updateTaskDueDates', true)
        this.closeModal()
      },
      doNotUpdateTasks() {
        this.$store.set('jobs/updateTaskDueDates', false)
        this.closeModal()
      },
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>

</style>
